module.exports = __webpack_public_path__ + "img/d3-logo.5e656126.svg";